import { formatCountdownDeadline } from './formatUtils';

/**
 * Calculate time remaining until a deadline
 * @param {Date|string} deadlineDate - The deadline date
 * @param {Function} t - Translation function
 * @returns {string|null} - Formatted time left string or null if deadline passed
 */
export const calculateTimeLeft = (deadlineDate, t) => {
  if (!deadlineDate) return null;

  // Parse the ISO date if it's a string
  const deadline = typeof deadlineDate === 'string' ? new Date(deadlineDate) : deadlineDate;
  const now = new Date();
  const timeLeftMs = deadline - now;

  if (timeLeftMs <= 0) return `0${t('sales.countdown.hours')}0${t('sales.countdown.minutes')}`;

  // Convert to total hours and minutes (no days)
  const totalHours = Math.floor(timeLeftMs / (1000 * 60 * 60));
  const minutes = Math.floor((timeLeftMs % (1000 * 60 * 60)) / (1000 * 60));

  return `${totalHours}${t('sales.countdown.hours')}${minutes}${t('sales.countdown.minutes')}`;
};

/**
 * Calculate countdown information for shipping deadline
 * @param {Object} sale - Sale object containing shipping deadline info
 * @param {Function} t - Translation function
 * @returns {Object|null} - Countdown info with timeLeft and deadline, or null if not applicable
 */
export const calculateCountdown = (sale, t) => {
  if (!sale || sale.status !== 'PAID') return null;

  // Use the sellerShippingDue date from the API
  let deadlineDate = sale.sellerShippingDue ? new Date(sale.sellerShippingDue) : null;

  // If no deadline is provided, fall back to the old calculation (3 days from creation)
  if (!deadlineDate) {
    const orderDate = sale.createdAt ? new Date(sale.createdAt) : new Date();
    deadlineDate = new Date(orderDate);
    deadlineDate.setDate(deadlineDate.getDate() + 3);
  }

  // Format deadline date for display in Japanese format
  const formattedDeadline = formatCountdownDeadline(deadlineDate);

  // Calculate time remaining using the shared function
  const timeLeft = calculateTimeLeft(deadlineDate, t);

  if (!timeLeft || timeLeft.startsWith('0')) return { timeLeft: '0時間0分', deadline: formattedDeadline };

  return { timeLeft, deadline: formattedDeadline };
};
